import color from "../../../../constants/color";

const styles = {
  cardTitle:{
    fontSize:"18px",
    fontWeight:"600",
    color:color.text
  },
  textCenter:{
    display: "flex",
    height: "80%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"},
  textNo:{
    fontSize:"16px",
    fontWeight:"400",
    color:color.lightText
  },
  boxNotification:{
    display:"flex",
    flexDirection:"row",
    justifyContent:"space-between",
    padding: "10px 0px 0px 10px",
  },
  viewAll:{
    fontSize:"14px",
    fontWeight:"400"
  },
  timesheetGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "12px",
    marginTop: "10px"
  },
  timesheetCard: {
    width: "98%",
    border: "1px solid #e0e0e0",
    borderRadius: "12px",
    padding: "12px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "131px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.06)"
  },
  timesheetLabel: {
    fontSize: "22px",
    fontWeight: "500",
    color: color.lightText,
    marginBottom: "4px"
  },
  timesheetValue: {
    fontSize: "22px",
    fontWeight: "700",
    color: color.text
  }


};
export default styles;